export const FILTER_LIST_TEST_IDS = {
  HEADER: 'filter-header',
  CLOSE_BTN: 'filter-close-btn',
  CLEAR_BTN: 'filter-clear-btn',
  APPLY_BTN: 'filter-apply-btn',
} as const;

